/**
 * Builds a Google search for public profiles (an "X-ray" search). The recruiter runs it in their
 * own browser; nothing is fetched or stored by us until they add someone as a candidate.
 */
export const WEB_SITES = {
  linkedin: { label: "LinkedIn", scope: "site:linkedin.com/in", source: "LinkedIn (web search)" },
  github: { label: "GitHub", scope: "site:github.com -inurl:issues -inurl:pull -inurl:blob", source: "GitHub (web search)" },
} as const;
export type WebSite = keyof typeof WEB_SITES;

/** A term as Google reads it: quoted when it has spaces or punctuation Google would split on. */
export function term(s: string): string {
  const t = s.replace(/"/g, "").trim();
  return /[\s.+#/-]/.test(t) ? `"${t}"` : t;
}

export interface WebSearch {
  site: WebSite;
  role: string;
  place: string;
  skills: string[];
  /** Any one of the skills rather than all of them. */
  anySkill: boolean;
}

export function webQuery({ site, role, place, skills, anySkill }: WebSearch): string {
  const parts: string[] = [WEB_SITES[site].scope];
  if (role.trim()) parts.push(`"${role.replace(/"/g, "").trim()}"`);
  const terms = skills.map(term).filter(Boolean);
  if (terms.length) parts.push(anySkill && terms.length > 1 ? `(${terms.join(" OR ")})` : terms.join(" "));
  if (place.trim()) parts.push(term(place));
  return parts.join(" ");
}

export const googleUrl = (query: string) => `https://www.google.com/search?q=${encodeURIComponent(query)}`;
